import { makeAutoObservable } from "mobx";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { LogRow, Result } from "../Model/log";
import { firestore } from "../firebase";
import { v4 } from "uuid";

export interface LiveScoreResult extends Result {
  liveDocID: string;
}

class LiveScoreStore {
  public logResults: LiveScoreResult[] = [];
  constructor() {
    makeAutoObservable(this);
    this.loadLive();
  }

  public addScore(result: LiveScoreResult) {
    result.liveDocID = v4();
    addDoc(collection(firestore, "livescores"), result)
      .then((doc) => {
        this.loadLive();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  private async loadLive() {
    const pulledData = [] as LiveScoreResult[];
    await getDocs(collection(firestore, "livescores"))
      .then((obj) => {
        this.logResults = [];
        obj.docs.forEach((v) => {
          const d = v.data() as LiveScoreResult;
          d.id = v.id;
          pulledData.push(d);
        });
        this.logResults = pulledData;
      })
      .catch((e) => {
        console.error("Failed to retrieve due to ", e);
      });
  }

  public async getLiveLogData(tournamentID: string) {
    const liveLog: LogRow[] = [];

    this.logResults.forEach((lr) => {
      // liveLog.push({
      //   draws: lr.away_goals === lr.home_goals ? 1 : 0,
      //   games:
      // })
    });

    return liveLog;
  }

  public async updateGame(game_id: string, updated: LiveScoreResult) {
    await updateDoc(doc(firestore, `livescores/${game_id}`), {
      away_goals: updated.away_goals,
      home_goals: updated.home_goals,
    })
      .then((f) => {
        console.log(`Successfully updated live game details ${f}`);
      })
      .catch((e) => {
        console.error(`Failed to update details`);
      });
  }

  public async deleteGame(id: string) {
    await deleteDoc(doc(firestore, `livescores/${id}`))
      .then(() => {
        console.log("successfully deleted object");
      })
      .catch((e) => {
        console.error(e);
      });

    this.loadLive();
  }
}

const liveScoreStore = new LiveScoreStore();
export { liveScoreStore };
